(function () {
    'use strict';

    angular
        .module('app.dailyLogs')
        .factory('logEntryViewDialog', logEntryViewDialog);

    logEntryViewDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];
    /* @ngInject */
    function logEntryViewDialog($modal, $templateCache, opsIncludeVersion) {
        var service = {
            display: display
        }

        $templateCache.put('logEntryViewDialog.tpl.html?v=' + opsIncludeVersion,
             '<div >' +
             '    <div class="modal-header">' +
             '        <button type="button" class="close" data-dismiss="modal" ' +
             '            aria-hidden="true" data-ng-click="vm.cancel()">&times;</button>' +
             '        <h3>Log Details</h3>' +
             '    </div>' +
             '    <div class="modal-body" ng-include="\'app/dailyLogs/_readonlyView.html?v=' + opsIncludeVersion + '\'" ng-init="item = vm.item">' +
             '    </div>' +
             '    <div class="modal-footer">' +
             '        <button class="btn btn-primary" data-ng-click="vm.cancel()"><i class="fa fa-close"></i>Close</button>' +
             '    </div>' +
             '</div>');

        return service;

        function display(logTypeId, entryId) {
            var modalOptions = {
                templateUrl: 'logEntryViewDialog.tpl.html?v=' + opsIncludeVersion,
                controller: LogEntryViewController,
                controllerAs: "vm",
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            logTypeId: logTypeId,
                            entryId: entryId
                        };
                    }
                }
            };

            return $modal.open(modalOptions).result;
        }
    }


    LogEntryViewController.$inject = ['$uibModalInstance', 'options', 'common', 'dataservice'];

    /* @ngInject */
    function LogEntryViewController($modalInstance, options, common, dataservice) {
        /*jshint validthis: true */
        var vm = this;
        vm.item = null;
        vm.getSingleItemAnswerText = getSingleItemAnswerText;
        vm.selectedOnly = selectedOnly;
        vm.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        vm.formatDateTimeAnswer = formatDateTimeAnswer;

        activate();

        function activate() {
            var promises = [getItem()];
            return common.$q.all(promises).then(function () {
            }, function (error) { });
        }

        function selectedOnly(item) {
            return item.Selected;
        }

        function getSingleItemAnswerText(question) {
            var answer = question.Answer;
            for (var i = 0; i < question.Items.length; i++) {
                if (question.Items[i].ID == answer) {
                    return question.Items[i].Description;
                }
            }
        }

        function formatDateTimeAnswer(answer, isDate) {
            if (answer) {
                var m = moment(answer);
                if (isDate) {
                    return m.format("L");
                }
                else {
                    return m.format("LT");
                }
            }
        }

        function getItem() {
            return dataservice.getItem('api/DailyLogs/EntryForLogType/' + options.logTypeId + '/' + options.entryId)
                .then(function (data) {
                    if (data) {
                        vm.item = data.data;
                    } else {
                        common.logger.warning('Could not load entry');
                    }
                })
                .catch(function (error) {
                    common.logger.error('Error locating entry');
                });
        }
    }
})();
